import { Button, Typography } from '@pw-tech/omni-ui'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AssistedSales from '@assets/images/ambassdor/AssistedSales'
import BatchSales from '@components/Sales/BatchSales/BatchSales'
import styles from './AssistedEarnCard.module.css'
import AssistEarnPopupCard from '@components/Sales/AssistEarnPopupCard/AssistEarnPopupCard'
import questionMarkCircle from '@assets/images/sales/question-mark-circle.svg'
import { PROGRAM_TYPE } from '@utils/enum'

const AssistEarnCard = ({
  isOpenPopupCard,
  onClose,
  setIsOpenGuideModal,
  isActive,
  setIsOpenAssistedVideoModal,
  isFirstTime,
  cameFrom,
}: any) => {
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const subHeading =
    'Guide students instantly through the batch selection and checkout process. Discounts are auto-applied, and you earn a special commission on every successful sale!'
  return (
    <>
      <div
        className={`bg-white shadow-md rounded-lg justify-between items-center w-full mx-auto  hidden lgxl:flex relative ${
          isOpenPopupCard ? 'z-[51] opacity-100' : 'z-0 opacity-100'
        }`}
      >
        <div className="flex-1 px-6 py-8 w-full sm:w-[70%]">
          <div className="flex items-center mb-2 gap-3">
            <h1 className="text-2xl font-semibold text-[#1B2124]">
              Assist & Earn
            </h1>
            <span
              className={`${styles.shimmer} bg-[#F1C571] text-black text-xs px-3 py-1.5 rounded-md font-semibold`}
            >
              New
            </span>
          </div>
          <Typography className="text-[#757575] text-[16px] max-w-2xl">
            {subHeading}
          </Typography>
          <div className="flex gap-4 mt-6 flex-col lg:flex-row">
            <Button
              variant="primary"
              onClick={() => {
                navigate(`/cohort-selection`)
              }}
              className="w-[264px]"
              disabled={!isActive}
            >
              Explore & Checkout
            </Button>
            {cameFrom !== PROGRAM_TYPE.CSC_PROGRAM && (
              <Button
                variant="secondary"
                onClick={() => navigate('/dashboard/earn')}
                className="w-[264px]"
              >
                View Commission Structure
              </Button>
            )}
          </div>
          {isOpenPopupCard && (
            <AssistEarnPopupCard
              isOpen={isOpenPopupCard}
              onClose={onClose}
              setIsOpenGuideModal={setIsOpenGuideModal}
            />
          )}
        </div>

        {/* Right Image */}
        <div className="flex justify-self-end self-end overflow-clip rounded-lg">
          <AssistedSales />
        </div>
        <img
          className={
            'text-[#7B7F86] w-6 h-6 absolute top-3 right-3 cursor-pointer'
          } //web
          src={questionMarkCircle}
          alt="Question"
          onClick={() => {
            onClose()
            isFirstTime && setIsOpenAssistedVideoModal(true)
          }}
        />
        {isOpen && (
          <BatchSales
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            title="Batch Sales"
            description="This is a batch sales type designed for students enrolling in group classes or courses."
          />
        )}
      </div>

      {/* mweb component */}
      <div
        className={`bg-white rounded-xl shadow-md w-full relative block lgxl:hidden  ${
          isOpenPopupCard ? ' z-[51] ' : 'z-0'
        }`}
      >
        <div className="flex items-start justify-between px-4 pt-4">
          <div className="flex items-center gap-2 sm:gap-3">
            <h1 className="text-[18px] font-semibold text-[#1B2124]">
              Assist & Earn
            </h1>
            <span
              className={`${styles.shimmer} bg-[#F1C571] text-[#1B2124] text-[10px] px-[6px] py-[2px] rounded-md font-semibold`}
            >
              New
            </span>
          </div>
        </div>

        <p className="mt-1 text-[#757575] text-sm px-4">{subHeading}</p>

        <div className="mt-5 space-y-3 px-4 mb-4">
          <Button
            variant="primary"
            onClick={() => {
              navigate(`/cohort-selection`)
            }}
            className="sm:w-[264px] w-[170px]"
            disabled={!isActive}
          >
            Explore & Checkout
          </Button>

          {cameFrom !== PROGRAM_TYPE.CSC_PROGRAM && (
            <Button
              variant="secondary"
              onClick={() => navigate('/dashboard/earn')}
              className=" sm:w-[264px] w-[170px]"
            >
              View Commission Structure
            </Button>
          )}
        </div>
        <img
          className={
            'text-[#7B7F86] w-6 h-6 absolute top-3 right-3 cursor-pointer'
          }
          // src={questionMarkCircle}
          alt="Question"
          onClick={() => {
            onClose()
            isFirstTime && setIsOpenAssistedVideoModal(true)
          }}
        />

        <div className="absolute right-0 w-32 sm:w-44 h-32 sm:h-44 overflow-hidden bottom-0 rounded-xl">
          <AssistedSales className="w-32 -mt-[44px] sm:w-44 sm:-mt-[19px] " />
        </div>
        {isOpenPopupCard && (
          <AssistEarnPopupCard
            isOpen={isOpenPopupCard}
            onClose={onClose}
            setIsOpenGuideModal={setIsOpenGuideModal}
          />
        )}
      </div>
    </>
  )
}

export default AssistEarnCard
